// import CheckIcon from '@material-ui/icons/Check'

import { useStyles } from './styles/index.styles'

interface StepIconProps {
  active: boolean
  completed: boolean
  icon: React.ReactNode
}

export function CustomStepIcon(props: StepIconProps) {
  const classes = useStyles({ active: props.active })
  return (
    <div
      className={[
        props.completed && classes.completedIcon,
        classes.stepIconRoot
      ].join(' ')}>
      {props.icon}
    </div>
  )
}
